import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
@Pipe({
  name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {

  programInfo: any;
  constructor(sharedService: SharedService) {
    this.programInfo = sharedService.programInfo;
  }

  transform(value: number,tofix?:number): any {
    if (value) {
      let abs: any = Math.abs(value);
      if (abs >= Math.pow(10, 12) && this.programInfo !== undefined) {
        // trillion
        let val: any =
          (value / Math.pow(10, 12)).toFixed(
           tofix ?? this.programInfo.point_decimal_scale
          ) + 'T';
        value = val;
      } else if (
        abs < Math.pow(10, 12) &&
        abs >= Math.pow(10, 9) &&
        this.programInfo !== undefined
      ) {
        // billion
        let val: any =
          (value / Math.pow(10, 9)).toFixed(
           tofix ?? this.programInfo.point_decimal_scale
          ) + 'B';
        value = val;
      } else if (
        abs < Math.pow(10, 9) &&
        abs >= Math.pow(10, 6) &&
        this.programInfo !== undefined
      ) {
        // million
        let val: any =
          (value / Math.pow(10, 6)).toFixed(
            tofix ?? this.programInfo.point_decimal_scale
          ) + 'M';
        value = val;
      } else if (
        abs < Math.pow(10, 6) &&
        abs >= Math.pow(10, 3) &&
        this.programInfo !== undefined
      ) {
        // thousand
        let val: any =
          (value / Math.pow(10, 3)).toFixed(
           tofix ?? this.programInfo.point_decimal_scale
          ) + 'K';
        value = val;
      }
    }
    return value;
  }

}
